import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=fb62fa5a&scoped=true&"
import script from "./StatusIcon.vue?vue&type=script&lang=js&"
export * from "./StatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./StatusIcon.vue?vue&type=style&index=0&id=fb62fa5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb62fa5a",
  null
  
)

component.options.__file = "StatusIcon.vue"
export default component.exports